import { Text } from '@mantine/core'
import { useForm } from '@mantine/form'
import { ContextModalProps } from '@mantine/modals'
import Form from 'common/Form'
import StockInput from 'common/inputs/StockInput'
import { useTakeVariant } from 'hooks/variants'
import { Category, Unit, VariantBase } from 'types/products'

type Props = {
  variant: VariantBase
}

export default function TakeProductModal({ context, id, innerProps: { variant } }: ContextModalProps<Props>) {
  const take = useTakeVariant()
  const form = useForm<{ stock: number; unit: Unit }>({
    validate: {
      stock: (value) => {
        if (!value) return 'Podaj ilość do pobrania'
        if (isNaN(Number(value))) return 'Wartość musi być liczbą'
        if (Number(value) <= 0) return 'Wartość musi być większa od zera'
        if (Number(value) > variant.stock) return 'Nie ma tyle produktu na stanie'
        return null
      },
    },
  })

  async function submit(formValues: { stock: number }) {
    await take.mutateAsync({ variant, amount: formValues.stock })
  }

  return (
    <Form onSubmit={submit} form={form} onCancel={() => context.closeModal(id)} submitText="Pobierz">
      <Text size="sm">
        Pobierz produkt o {variant.category === Category.FABRIC ? 'wysokości' : 'wymiarze'} <b>{variant.size}</b>{' '}
        {variant.category === Category.FABRIC ? 'cm' : ''} z półki{' '}
        <b>
          {variant.place.rack}-{variant.place.column}-{variant.place.shelf}
        </b>
        . Dostępnych jest <b>{variant.stock}</b>{' '}
        {variant.unit === Unit.PIECE ? 'sztuk' : variant.unit === Unit.METER ? 'metrów' : 'centymetrów'}.
      </Text>
      <StockInput
        form={form}
        category={variant.category}
        description="Ile produktu chcesz pobrać z magazynu?"
        autoFocus
      />
    </Form>
  )
}
